import React, { useRef, useState, useMemo, useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService.jsx";
import DataGridComponent from '../../common/DataGridComponent/DataGridComponent.jsx';
import Spinner2 from "../../common/Spinner/Spinner2.jsx";
import commonApiService from '../../../../shared/common-utilities/services/commonApiService.jsx';
import { getPostalCode, fetchSavedView  } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts.jsx';
import { Grid } from '@mui/material';
import AlertComponent from '../../../../shared/common-utilities/common/AlertComponent.jsx';
import ActionButton from '../../../../shared/common-utilities/common/ActionButton.jsx';

const entity = "postCode";
let entityNameFor = "postCode";
const odataApiName = "postCodes";
let odataApiNameFor = "postCodes";
let service = getSetDataService();
let apiService = commonApiService();
const dataRelatedAction = ['Filter', 'View Columns', 'Settings', 'Refresh', 'New Window'];
let gridSelectedValues = {};
//#region SortData start

const PostalCode = (props) => {
  //#region Reference
  const postCodesGrid = useRef(null);
  //#endregion Reference

  //#region Hook Selctor
  //#endregion Hook Selctor

  const postCodesGridDataItemKey = "id";
  const initialSort = service.initialSort[entity];

  //#region States - Get set variables
  const [tempPostCodesData, setTempPostCodesData] = useState([]);
  const [postCodesGridColumnList, setPostCodesGridColumnList] = React.useState(null);
  const [tempPostCodesGridColumnList, setTempPostCodesGridColumnList] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isPostCodes, setIsPostCodes] = useState(true);
  const [loadedGridData, setLoadedGridData] = useState(tempPostCodesData);
  const [myGridData, setmyGridData] = React.useState([]);
  const [loadSelectionValue, setloadSelectionValue] = useState(100);
  const [totalData, setTotalData] = useState();
  const userID = localStorage.getItem('userID');
  
  const [isApiLoaded, setIsApiLoaded] = useState(false);
  const [paramsData, setParamsData] = useState(null);
  let [initialFilter, setInitialFilter] = useState([]);
  const [nextDataUrl, setNextDataUrl] = useState(null);
  const [postCodesData,setPostCodesData] = useState({});
  const [initialSaveViewData, setInitialSaveViewData] = useState([]);
  const [initialFetchReadLinkData, setInitialFetchReadLinkData] = useState(null);
  const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
  const [changeToChildPC, setChangeToChildPC] = useState(null);
  const [isApiCallRequired, setIsApiCallRequired] = useState(true);

  const postCodesFilterComponents = [];
  //#endregion States

  //#region Hooks  

  useEffect(() => {
    // setIsLoading(true);

    setIsApiLoaded(true);
    entityNameFor = entity + (props?.params?.for ? props?.params?.for : '');
    odataApiNameFor = odataApiName + (props?.params?.for ? props?.params?.for : '');
    setGridColumns(entity);

    let tempFilterData = [];
    tempFilterData.push({ field: 'country', value: '=' + props?.country, isLast: false, type: 'Edm.String' });

    setInitialFilter(tempFilterData);
  }, []);

  const setGridColumns = (entityName) => {
    const columnList = localStorage.getItem(entityNameFor + 'ColumnList');
    if (!_.isNil(columnList)) {
        setPostCodesGridColumnList(JSON.parse(columnList));
        getColList(JSON.parse(columnList));
        return true;
    }

    apiService.getODataMetadata().then(odataRes => {
      service.entityDefinitions(odataRes, entityName).then((tempFieldList) => {
        localStorage.setItem(entityNameFor + 'ColumnList', JSON.stringify(tempFieldList));
        setPostCodesGridColumnList(tempFieldList);
        getColList(tempFieldList);
      })
    })
    .catch(error => {
      console.error('API error:', error);
    })
  }

  const getDefaultColList = (dcolsStringSC, gridcolumns) => {
    const dCols = JSON.parse(localStorage.getItem("defaultColumnSetting"));
    if (!_.isNil(dcolsStringSC) && dcolsStringSC != "undefined" ) {
      const defaultColumnListSC = gridcolumns?.filter(item => {
        return dCols[entity]?.split("~").includes(item.field);
      });
      if (defaultColumnListSC.length == 0) {
        localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(gridcolumns));
        setTempPostCodesGridColumnList(gridcolumns);
      } else {
        const sortedArr = _.sortBy(defaultColumnListSC, function (item) { return dCols[entity]?.split("~").indexOf(item.field) });
        localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(sortedArr));
        setTempPostCodesGridColumnList(sortedArr);

        const arr1 = sortedArr;
        const arr2 = gridcolumns.filter(e => !sortedArr.map(x => x.field).includes(e.field));
        const newsortedArr = _.concat(arr1, arr2);
        setPostCodesGridColumnList(newsortedArr);
      }
    } else {
      localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(gridcolumns));
      setTempPostCodesGridColumnList(gridcolumns);
    }
  }

  const getColList = (gridcolumns) => {
    const scUrl = `${fetchSavedView}?$filter=(title eq '${odataApiNameFor}' and userID eq '${userID}')`;
    const dcolsStringSC = localStorage.getItem("defaultColumnSetting");
    apiService.get(scUrl).then(savedViewRes => {
        if (savedViewRes?.value?.length > 0) {
            apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"], null, null, null, null, savedViewRes.value[0]["@odata.etag"]).then(readResSC => {
            if (readResSC !== undefined && readResSC !== null) {
                setInitialSaveViewData(savedViewRes.value);
                setInitialFetchReadLinkData(readResSC);
                const defaultViewExist = readResSC[odataApiNameFor]?.savedViews?.filter(item => item.defaultView);
                if (defaultViewExist?.length > 0 && defaultViewExist?.[0]?.subviews?.length > 0) {
                    const favFilterExist = defaultViewExist[0]?.subviews?.filter(subView => subView.isDefaultFilter);
                    if (favFilterExist?.length > 0) {
                        setTempPostCodesGridColumnList(defaultViewExist[0].columns);
                    }
                } else if (readResSC[odataApiNameFor]?.columns?.length !== 0) {
                    localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(readResSC[odataApiNameFor]?.columns));
                    setTempPostCodesGridColumnList(readResSC[odataApiNameFor]?.columns);
                } else {
                    getDefaultColList(dcolsStringSC, gridcolumns);
                }
            }
            })
        } else {
            getDefaultColList(dcolsStringSC, gridcolumns);
        }

      setIsLoading(false);
    });
  }

  useEffect((e) => {
    if (!_.isNil(paramsData) && isApiCallRequired) {
      updateSendApi(loadSelectionValue);
    } else {
      setIsApiCallRequired(true);
    }
  }, [paramsData]);

  useEffect((e) => {
    if (!_.isNil(tempPostCodesGridColumnList)) {
      setNextDataUrl(null);
      updateSendApi(loadSelectionValue);
    }
  }, [tempPostCodesGridColumnList]);

  // --- API's Call START ---
  
  const sendApi = (val, size) => {
    let filter = paramsData?.filter ? '$filter=(' + paramsData?.filter + ')' : null;
    let orderby = paramsData?.orderby ? '$orderby=' + paramsData?.orderby : null;
    if (tempPostCodesGridColumnList !== null && tempPostCodesGridColumnList !== undefined && tempPostCodesGridColumnList?.length > 0) {
      setIsLoading(true);
      const params = '&' + filter + '&' + orderby + '&$count=true';
      const columns = tempPostCodesGridColumnList?.map(item => item.field);
      const mandatroyEntity = JSON.parse(localStorage.mandatoryColumnList).find(e => e.entity == odataApiName);
      if (!_.isNull(mandatroyEntity)) {
        let splitedColums = mandatroyEntity.mandatoryColumns.split("~");
        splitedColums.forEach(element => {
          if (!columns.includes(element)) {
            columns.push(element)
          }
        });
      }

      const selectFields = `&$select=${columns}`;
      const oDataNextLink = val == 'Scroll' ? nextDataUrl : null;
      apiService.get(getPostalCode, params, `${selectFields}`, oDataNextLink, size, null).then(response => {
        if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
          if (response?.error?.message?.includes('$orderby')) {
            const sortToRemoveSC = response.error.message.split("'")[1];
            setChangeToChildPC({ type: "sort", value: sortToRemoveSC });
          } else if (response?.error?.code == "Application_FilterErrorException") {
            const filterToRemoveSC = response.error.message.split("'")[1];
            setChangeToChildPC({ type: "filter", value: filterToRemoveSC });
          }
        } else {
          if (response.value) {
            setTotalData(response["@odata.count"]);
            let tempData = [];
            if (val == 'Scroll' && tempPostCodesData !== null && tempPostCodesData !== undefined && tempPostCodesData.length > 0) {
                tempPostCodesData.forEach(tempContractor => {
                tempData.push(tempContractor);
              });
              response.value.map(temp => {
                tempData.push(temp)
              })
            }
            // Update the data based on the response
            else {
              tempData = response.value;
            }

            tempData = service.setColorCodeAndDate(tempData, postCodesGridColumnList);
            setIsApiLoaded(true);
            if (response['@odata.nextLink'] !== null && response['@odata.nextLink'] !== undefined) {
              setNextDataUrl(response['@odata.nextLink']);
            }

            setmyGridData(tempData);
            setLoadedGridData(tempData);
            setTempPostCodesData(tempData);
          }
        }
      })
        .catch(error => {
          console.error('API error:', error);
        })
        .finally(() => {
          setIsLoading(false);
          if (props?.sendDataToParent) {
            props.sendDataToParent(odataApiName);
          }
        });
    } else {
      setIsLoading(false);
    }
  }

  const updateSendApi = useMemo(() => {
    return _.debounce((size) => {
      sendApi(null, size);
    }, 250);
  }, [sendApi]);
  
  // --- API's Call END ---

  //#endregion Hooks

  const childStateHandler = (value, flag) => {
    if (flag === 'showGridHeader') {
        setIsPostCodes(value);
    } else if (flag === 'getData') {
      setNextDataUrl(null);
      setParamsData({ ...paramsData, filter: value.filter, orderby: value.orderby });
      setIsApiCallRequired(value.isApiCall);
      setTempPostCodesGridColumnList(value.columns);
    } else if (flag === 'refresh') {
      sendApi(null, loadSelectionValue);
    } else if (flag === 'selectedValues') {
      gridSelectedValues = value;
    } else if (flag === 'dataItem') {
        setPostCodesData(value); 
    } else if (flag === 'columnsVisible') {
        setTempPostCodesGridColumnList(value);
    }
  }

  const closePopup = () => {
    props.onClose();
  }

  const onOkClick = () => {
    let transferdataId = Object.entries(gridSelectedValues).filter(([key, value]) => value === true).map(([key]) => key);
    if (transferdataId.length === 0) {
      setErrorSnackbarMessage('Please select Transport Address');
      setErrorSnackbarOpen(true);
      return;
    }    
    props.addAddress(postCodesData);
  }
  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorSnackbarOpen(false);
  };

  const onLoadSelectionChange = (e) => {
    let value = e.value;
    setloadSelectionValue(value);
    sendApi(null, value);
  }

  const setErrorParameterAndMessage = (errMsg) => {
    setCommonPopupParameters({
      title: 'Error'
    });
    setErrorMessage(errMsg);
    setopenConfirmationModal(true);
  }

  return (
    <>
      {isLoading ? (<Spinner2 isAll={loadSelectionValue} />) : (<></>)}
      <Grid item xs={12} square component={Card} elevation={0} sx={{ p: 1, width: '100%' }} id={odataApiName}>

        <AlertComponent isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose} />

        {isPostCodes && <Box className="headBG" sx={{ px: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>Postal Code</Typography>
        </Box>}
        <Grid container sx={{ marginTop: 0 }}  >
          <Grid item={true} xs component={Card} elevation={0} pl={0} sx={{ flexGrow: 1 }} className='grid-movement'>
            {isApiLoaded && <DataGridComponent
              {...props}
              gridRef={postCodesGrid}
              gridFlagVal={odataApiName}
              gridFlagValFor={odataApiNameFor}
              gridStyle={{ maxHeight: 'calc(100%)', height: '100%', minHeight: '650px' }}
              gridNewData={myGridData}
              loadedGridData={loadedGridData}
              tempGridData={tempPostCodesData}
              gridColumnList={postCodesGridColumnList ? postCodesGridColumnList : []}
              gridTempColumnList={tempPostCodesGridColumnList ? tempPostCodesGridColumnList : []}
              isItemVisible={true}
              gridSort={initialSort}
              gridInitialFilter={initialFilter}
              isShowGridHeader={isPostCodes}
              griddDtaItemKey={postCodesGridDataItemKey}
              gridDraggable={false}
              sendDataToParent={childStateHandler}
              gridDataAction={dataRelatedAction}
              gridFilterComponents={postCodesFilterComponents}
              onLoadSelectionChange={onLoadSelectionChange}
              loadSelectionValue={loadSelectionValue}
              gridtotalData={totalData}
              initialSaveViewData={initialSaveViewData}
              initialFetchReadLinkData={initialFetchReadLinkData}
              selectableMode={"single"}
              changeToChild={changeToChildPC}
            />}
          </Grid>
        </Grid>
      </Grid>
      <ActionButton onOkClick={onOkClick} closePopup={closePopup}/>
    </>
  )
};

export default PostalCode;